<template>
  <main class="dashboard ope-form">
    <div class="container-fluid container-fluid--max">
      <div class="card">
        <div class="card-body">
          <router-link :to="{ name: 'interventions' }" tag="a" class="back btn btn-link uppercase smaller pl-0">
            <i class="back__icon fa fa-close mr-h" aria-hidden="true"></i>Retour
          </router-link>
          <section class="dash-ope-form px-lg-5 mt-4">
            <h1 class="dashboard__title heading-primary">{{ reportFormTitle }}</h1>
            <InterventionHeader :intervention="intervention" :buttons="false" class="my-4 py-2" />
            <vv-observer tag="form" v-slot="{ invalid }" @submit.prevent="submit">
              <h2 class="dashboard__title heading-secondary my-3">Infos générales</h2>
              <div class="form-group">
                <label class="access-form__label">Anomalies signalées</label>
                <textarea v-model="params.reported_defects" class="access-form__textarea form-control"></textarea>
              </div>
              <div class="row">
                <div class="col-md">
                  <r-input label="Types de pellets" v-model="params.pellet_type" :required="false" />
                  <ReportSettings :settings-summary="params.settings_summary" @settings="setSettings" />
                </div>
                <div class="col-md">
                  <div class="form-group">
                    <label class="access-form__label">Pièces remplacées</label>
                    <textarea v-model="params.replaced_parts" class="form-control"></textarea>
                  </div>
                  <div class="form-group mb-sm-0 align-self-center">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" v-model="params.replaced_parts_under_guarantee" id="replacedParts" class="custom-control-input" />
                      <label class="custom-control-label access-form__label" for="replacedParts">Pièces remplacées sous garantie</label>
                    </div>
                  </div>
                </div>
              </div>
              <h2 class="dashboard__title heading-secondary my-3">Installation</h2>
              <div class="form-group">
                <label class="access-form__label">Constatations diverses</label>
                <textarea v-model="params.installation_comments" class="access-form__textarea form-control"></textarea>
              </div>
              <!-- <r-input label="Pellets utilisé" v-model="params.pellet_used" :required="false" /> -->
              <div class="form-group mb-sm-0 align-self-center">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" v-model="params.standard_installation" id="standardInstall" class="custom-control-input" />
                  <label class="custom-control-label access-form__label" for="standardInstall">Installation conforme</label>
                </div>
              </div>
              <div class="form-group mt-3">
                <label class="access-form__label">Anomalies constatées</label>
                <textarea v-model="params.observed_defects" class="access-form__textarea form-control"></textarea>
              </div>

              <div class="form-row">
                <div class="form-group col-sm" v-for="file in files" :key="file.idx">
                  <label class="access-form__label">Photo ou dessin</label>
                  <div class="custom-file">
                    <input type="file" class="custom-file-input" :id="'file-' + file.idx" :ref="file.ref" @change="setfile(file.ref)">
                    <label class="custom-file-label" :for="'file-' + file.idx">
                      {{ file.fileName || 'Parcourir' }}
                    </label>
                  </div>
                </div>
              </div>
              <h2 class="dashboard__title heading-secondary my-3">Conclusion</h2>
              <div class="form-row">
                <div class="form-group col-sm">
                  <label class="access-form__label">Facture</label>
                  <div class="custom-file">
                    <input type="file" class="custom-file-input" id="billFile" ref="bill" @change="setBillFile">
                    <label class="custom-file-label" for="billFile">
                      {{ bill.fileName || 'Parcourir' }}
                    </label>
                  </div>
                </div>
                <r-input label="Nom du technicien" v-model="params.name" icon="user-o" class="col-sm" name="nom" />
              </div>
              <div class="form-row">
                <d-input v-model="params.intervention_date" label="Date de l'intervention" class="col-sm" rules="required" name="date" />
                <r-input label="Heure d'arrivée" type="time" v-model="params.start_time" icon="clock-o" class="col-sm" name="heure d'arrivée" />
                <r-input label="Heure de départ" type="time" v-model="params.end_time" icon="clock-o" class="col-sm" name="heure de départ" />
              </div>

              <div class="d-flex justify-content-center">
                <s-button :loading="loading" @submit="submit(true)" :css-class="'mx-2 px-5 btn-warning'">
                  Brouillon
                </s-button>
                <s-button :loading="loading" @submit="submit(false)" :css-class="'px-5 btn-' + $mainColor" :disabled="invalid || loading">
                  Enregistrer
                </s-button>
              </div>
            </vv-observer>
          </section>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import InterventionHeader from './../InterventionHeader'
import ReportSettings from './ReportSettings'
import { mapState, mapGetters } from 'vuex'
import store from '@/store'

export default {
  name: 'InterventionReport',
  components: {
    InterventionHeader,
    ReportSettings
  },
  props: {
    id: {
      type: [String, Number],
      required: true
    },
    reportId: {
      type: [String, Number],
      required: true
    }
  },
  data () {
    return {
      loading: false,
      intervention: {},
      formData: new FormData(),
      params: {
        replaced_parts_under_guarantee: false,
        standard_installation: false
      },
      files: [
        { idx: 0, ref: 'file0', fileName: null, id: null },
        { idx: 1, ref: 'file1', fileName: null, id: null },
        { idx: 2, ref: 'file2', fileName: null, id: null }
      ],
      bill: {
        fileName: null
      }
    }
  },
  computed: {
    ...mapState(['currentUser', 'userAuth']),
    ...mapGetters({ allInterventions: `${store.$appName}/allInterventions` }),
    creation () {
      return this.reportId === 'new'
    },
    reportFormTitle () {
      return this.creation ? 'Rédiger un rapport d\'intervention' : 'Éditer le rapport d\'intervention'
    },
    request () {
      let url = `/users/${this.currentUser.id}/interventions/${this.id}/intervention_reports/`
      return {
        method: this.creation ? 'post' : 'put',
        url: this.creation ? url : url + this.reportId,
        headers: {
          ...this.userAuth,
          'Content-Type': 'multipart/form-data'
        }
      }
    }
  },

  created () {
    this.intervention = this.allInterventions.find(inter => inter.id === parseInt(this.id))
    if (!this.creation) {
      let report = this.intervention.report
      this.params = _.clone(report)

      this.getBillFile()
      this.getFiles()
    }
  },
  methods: {
    setSettings (settings) {
      this.formData.append('intervention_report[settings_summary]', JSON.stringify(settings))
    },
    getBillFile () {
      let bill = this.params.bill
      if (bill && bill.url) this.bill.fileName = bill.filename
    },
    getFiles () {
      _.map(this.files, file => {
        let current = this.params.attachments.find(f => f.name === file.ref)
        if (current) file.fileName = current.filename
        if (current && current.id) file.id = current.id
      })
    },
    setfile (ref) {
      let currentFile = _.find(this.files, file => file.ref === ref)
      if (this.$refs[ref][0].files.length > 0) {
        currentFile.fileName = this.$refs[ref][0].files[0].name
        if (currentFile.id) {
          this.formData.append(`intervention_report[attachments_attributes][${currentFile.idx}][id]`, currentFile.id)
        }
        this.formData.append(`intervention_report[attachments_attributes][${currentFile.idx}][document]`, this.$refs[ref][0].files[0])
      } else {
        currentFile.fileName = null
        this.formData.delete(`intervention_report[attachments_attributes][${currentFile.idx}][document]`)
      }
    },
    setBillFile (ref) {
      if (this.$refs.bill.files.length > 0) {
        this.bill.fileName = this.$refs.bill.files[0].name
        this.params.bill = this.$refs.bill.files[0]
      } else {
        this.bill.fileName = null
        this.params.bill = null
      }
    },
    submit (draft) {
      this.loading = true
      for (let key in this.params) {
        if (key !== 'settings_summary') {
          let value = this.params[key]
          if (value !== null) this.formData.append(`intervention_report[${key}]`, value)
        }
      }
      this.formData.append('intervention_report[draft]', draft)
      this.$http({
        method: this.request.method,
        url: this.request.url,
        headers: this.request.headers,
        data: this.formData
      }).then((resp) => {
        this.$store.dispatch('fetchInterventions').then(() => {
          this.loading = false
          this.$router.push({ name: 'interventions' })
        })
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    }
  }
}
</script>
